import { create } from "zustand";

/** Minimal problem detail shape for access-denied state (avoids importing from problem-detail to prevent circular deps). */
export interface AccessDeniedProblem {
  code?: string;
  status?: number;
  detail?: string;
  title?: string;
  instance?: string;
}

interface AccessDeniedState {
  showAccessDenied: boolean;
  problemDetail: AccessDeniedProblem | null;
  pathnameAt403: string | null;
  setAccessDenied: (problem: AccessDeniedProblem | null, pathname?: string | null) => void;
  clearAccessDenied: () => void;
}

export const useAccessDeniedStore = create<AccessDeniedState>((set) => ({
  showAccessDenied: false,
  problemDetail: null,
  pathnameAt403: null,

  setAccessDenied: (problem, pathname) =>
    set({
      showAccessDenied: problem != null,
      problemDetail: problem ?? null,
      pathnameAt403: pathname ?? null,
    }),

  clearAccessDenied: () =>
    set({
      showAccessDenied: false,
      problemDetail: null,
      pathnameAt403: null,
    }),
}));
